import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

function useNavigationStack(limit = 10) {
    const location = useLocation();
    const [stack, setStack] = useState([]);

    useEffect(() => {
        setStack((prev) => {
            const newStack = [...prev, location.pathname];

            // For keeping only last "limit" paths
            return newStack.slice(-limit);
        });
    }, [location]);

    useEffect(() => {
        console.log('stack ======= ', stack);
    }, [stack]);

    return stack;
}

export default useNavigationStack;
